import React, { memo, useMemo } from "react"

import { useWindowSize } from "../../../hooks/useWindowSize"

export const withAddToCart = Component =>
  memo(({ name = "AddToCart", ...props }: any) => {
    const {
      windowSize: { isMobile },
    } = useWindowSize()
    Component.displayName = name
    return useMemo(() => <Component {...props} isMobile={isMobile} />, [isMobile, props])
  })
